<template>
    <div
        v-if="!!log"
        :class="{ expandable: !!log.id && !log.automated && (log.description.length >= 80), expanded }"
        class="lam-log-item"
        @click.prevent.stop="expand(log)"
    >
        <div v-if="editing">
            <textarea
                ref="editor"
                placeholder="Log something..."
                v-model="edited_record.description"
                class="uk-width-1-1"
            ></textarea>
            <div class="uk-grid uk-flex-middle uk-grid-small uk-margin-small-top">
                <div class="uk-width-auto">
                    <label
                        v-if="!edited_record.id"
                        class="uk-form-label"
                    >
                        <input
                            type="checkbox"
                            :checked="!edited_record.type"
                            @click.stop="edited_record.type = ($event.target.checked ? 0 : 1)"
                        />
                        Reset Comms. Timer
                    </label>
                </div>
                <div class="uk-width-static">
                    <a href class="uk-button uk-button-small" @click.prevent="stop_editing">Cancel</a>
                </div>
                <div class="uk-width-static">
                    <a href class="uk-button uk-button-small uk-button-lam-orange" @click.prevent="save">Save</a>
                </div>
            </div>
        </div>
        <a v-else-if="!log.id" href="#" class="uk-button uk-button-small uk-width-1-1" @click.prevent="edit">
            Add a new log entry...
        </a>
        <div
            v-else
        >
            <span
                v-if="log.automated"
                class="uk-text-muted uk-text-uppercase"
            >
                {{ log.description }}
            </span>
            <div v-else v-html="log.description" v-linkified class="lam-log-text"></div>
            <div class="uk-text-muted">
                <small>
                    <open-icon glyph="clock-o" /> {{ log.executed_at | nibnut.date_from_now("MMMM DD, YYYY @ hh:mm a") }}, by {{ log.initials }}
                    <a v-if="can_or_db_admin(this.profile && (this.profile.initials===log.initials))" href="#" class="uk-icon-hover uk-icon-trash" @click.prevent="remove"></a>
                    <a v-if="!log.automated && (profile_id === log.user_id)" href="#" class="uk-icon-hover uk-icon-pencil uk-float-right uk-margin-right" @click.prevent="edit"></a>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
import profile_utilities from "../../../mixins/ProfileUtilities"

import OpenIcon from "../../../ui/OpenIcon"

import linkify from "vue-linkify"

export default {
    name: "LogItem",
    mixins: [profile_utilities],
    components: {
        OpenIcon
    },
    directives: {
        linkified: linkify
    },
    methods: {
        edit () {
            this.edited_record = {
                ...this.log
            }
            this.editing = true
            setTimeout(() => {
                this.$refs.editor.focus()
                this.$refs.editor.select()
            }, 200)
        },
        save () {
            if(!this.edited_record.id) {
                this.$store.dispatch("CREATE_RECORD", {
                    entity: "project_log",
                    data: {
                        ...this.edited_record,
                        executed_at: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
                        relation_ids: ["project"],
                        fields: ["ns::project;fieldset::default"]
                    }
                }).then(() => {
                    this.stop_editing()
                }).catch(error => {
                    this.$error(error.message)
                })
            } else {
                this.$store.dispatch("RECORD_SAVE", {
                    entity: "project_log",
                    id: this.edited_record.id,
                    data: {
                        description: this.edited_record.description
                    }
                }).then(() => {
                    this.stop_editing()
                }).catch(error => {
                    this.$error(error.message)
                })
            }
        },
        stop_editing () {
            this.edited_record = {}
            this.editing = false
        },
        remove () {
            this.$confirm({
                type: "error",
                title: "Delete Log Entry",
                message: `Do you really want to delete this entry by ${this.log.initials}? There is no undo...`,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch("RECORD_DELETE", {
                            entity: "project_log",
                            id: this.log.id,
                            data: {
                                relation_ids: ["project"],
                                fields: ["ns::project;fieldset::default"]
                            }
                        }).catch(error => {
                            if(error) this.$error(error.message)
                        })
                    }
                }
            })
        },
        expand () {
            if(!this.log || !this.log.id) return
            if(!this.expanded) this.expanded = true
        }
    },
    props: {
        log: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            expanded: false,
            edited_record: {},
            editing: false
        }
    }
}
</script>
